import {setAmplitudeUserProperties, trackAmplitudeEvent} from "@pg-mono/amplitude";

/*
 * `phone_verified` event spec: send `true` after the user verifies the phone number with a correct SMS code,
 * `false` when the verification popup is closed or the verification attempt fails.
 * A successful verification is additionally stored in Amplitude user properties.
 */
export const trackAmplitudePhoneVerified = (isPhoneVerified: boolean) => {
    trackAmplitudeEvent("phone_verified", {phone_verified: isPhoneVerified});

    if (isPhoneVerified) {
        setAmplitudeUserProperties({phone_verified: true});
    }
};
import {setAmplitudeUserProperties, trackAmplitudeEvent} from "@pg-mono/amplitude";

/*
 * `phone_verified` event spec: send `true` after the user verifies the phone number with a correct SMS code,
 * `false` when the verification popup is closed or the verification attempt fails.
 * A successful verification is additionally stored in Amplitude user properties.
 */
export const trackAmplitudePhoneVerified = (isPhoneVerified: boolean) => {
    trackAmplitudeEvent("phone_verified", {phone_verified: isPhoneVerified});

    if (isPhoneVerified) {
        setAmplitudeUserProperties({phone_verified: true});
    }
};
